<template>
  <div v-if="records.length === 0" class="p-movies">
    <div class="container">
      <div class="p-movies__empty">
        <i class="icon-camera"></i>
        <span>
          {{ dictionary.emptyRecordsText }}
        </span>
      </div>
    </div>
  </div>
  <div v-else class="p-movies__outerwrapper">
    <section
      :class="
        currentView === 'horizontal'
          ? 'p-movies s-strip'
          : 'p-movies__vertical s-strip'
      ">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-2 col-xl-2 p-movies__right-col">
            <Sticky>
              <PlayingNowFilters
                key="desktop-PlayingNowFilters"
                :cinema-filter-title="dictionary.cinemaFilterTitle"
                :education-filter-title="dictionary.educationFilterTitle"
                :genre-filter-title="dictionary.genreFilterTitle"
                :clear-filters="dictionary.clearFilter"
                :all-genres="dictionary.allGenres"
                :placeholders="filterPlaceholders"
                :selected-filters="selectedFilters"
                :show-filters="showFilters"
                :filters="filtersDataFiltered"
                :education-level="showEducationFilter"
                @filter-changed="updateSelectedFilters"
                @reset-filters="resetMoviesFilters"></PlayingNowFilters>
            </Sticky>
          </div>
          <div
            v-if="currentView === 'horizontal'"
            class="col-12 col-lg-10 col-xl-9 offset-sm-0 offset-xl-1">
            <!-- Tabs -->
            <div v-if="tabs && tabs.length > 0" class="e-tabs">
              <ul>
                <li
                  v-for="tab in tabs"
                  :key="tab.value"
                  class="e-tabs__tab"
                  :class="{ 'e-tabs__tab--active': activeTab === tab.value }"
                  @click="selectTab(tab.value)">
                  <span>{{ tab.display }}</span>
                </li>
              </ul>
            </div>

            <section class="p-movies__header-container">
              <div class="p-movies__header">
                <div class="p-movies__header__mobile-filters">
                  <div class="b-search-input b-search-input--no-btn">
                    <input
                      v-model="searchMovieTitle"
                      class="e-search"
                      type="text"
                      :placeholder="dictionary.movieSearch"
                      @input="startSearchMovies" />
                  </div>
                  <!-- <select
                    id="cinema"
                    v-model="mobileCinemaSelect"
                    name="cinema"
                    class="form-select"
                    @change="handleMobileCinemaChange">
                    <option value="all">
                      {{ dictionary.placeholderCinemas }}
                    </option>
                    <option
                      v-for="item in cinemas"
                      :key="item.value"
                      :value="item.value"
                      :disabled="item.disabled">
                      {{ item.display }}
                    </option>
                  </select> -->

                  <button
                    type="button"
                    class="s-playing-now__filters-btn"
                    @click="() => (showMobileFiltersModal = true)"></button>
                </div>
              </div>
            </section>

            <div class="row">
              <div
                v-for="(record, index) in displayedRecords"
                :key="index"
                class="col-12 col-sm-6 col-md-4">
                <MovieCard
                  :title="record.title"
                  :subtitle="record.subTitle"
                  :description="record.desc"
                  :image="record.thumb"
                  :pg="record.pg"
                  :duration="record.dur"
                  :dolby="record.dolby"
                  :three-dimensions="record.threeDimensions"
                  :imax="record.imax"
                  :imax3D="record.imax3D"
                  :sphera="false"
                  :genres="recordGenres(record)"
                  :dictionary="dictionary"
                  :due="record.due"
                  :video-id="record.vid"
                  :play="false"
                  :movie-id="record.movieId"
                  :transl="record.transl"
                  :movie-url="record.url"
                  :cinema-id="selectedCinemaId"
                  :only-members="record.onlyMembers"
                  :elementary-school="record.elementarySchool"
                  :middle-school="record.middleSchool"
                  :high-school="record.highSchool"
                  :elements-show-options="{
                    showPremier: false,
                    showTrailerCta: false,
                    showBookingCta: true,
                    showDuration: true,
                    showGenres: true,
                    showDesc: false,
                    showMoreCta: true,
                    posterCardDimensions: {},
                  }"></MovieCard>
              </div>
            </div>
            <div v-if="hasMoreRecords" class="p-movies__show-more">
              <button
                type="button"
                class="p-movies__show-more-btn"
                @click="showAllRecords">
                <span>{{ dictionary.showMore || 'Show More' }}</span>
              </button>
            </div>
          </div>
          <div v-else class="col-12 col-lg-9 offset-lg-1">
            <div class="row">
              <div
                v-for="(record, index) in displayedRecords"
                :key="index"
                class="col-12 col-sm-6 col-md-12">
                <MovieHorizontalCard
                  :key="record.id"
                  :title="record.title"
                  :description="record.desc"
                  :image="record.thumb"
                  :pg="record.pg"
                  :duration="record.dur"
                  :genres="recordGenres(record)"
                  :dictionary="dictionary"
                  :sub-title="record.subTitle"
                  :dolby="record.dolby"
                  :three-dimensions="record.threeDimensions"
                  :imax="record.imax"
                  :imax3d="record.imax3D"
                  :sphera="false"
                  :movie-id="record.movieId"
                  :movie-url="record.url"
                  :cinema-id="selectedCinemaId" />
              </div>
            </div>
            <div v-if="hasMoreRecords" class="p-movies__show-more">
              <button
                type="button"
                class="p-movies__show-more-btn"
                @click="showAllRecords">
                {{ dictionary.showMore || 'Show More' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ModalOverlay v-model="showMobileFiltersModal" size="player">
      <template #header>
        <i class="icon-filters"></i>
        <div class="b-pop-up__header__title">{{ dictionary.filters }}</div>
      </template>
      <template #body>
        <div class="b-pop-up__content">
          <PlayingNowFilters
            key="desktop-PlayingNowFilters"
            :cinema-filter-title="dictionary.cinemaFilterTitle"
            :education-filter-title="dictionary.educationFilterTitle"
            :genre-filter-title="dictionary.genreFilterTitle"
            :clear-filters="dictionary.clearFilter"
            :all-genres="dictionary.allGenres"
            :placeholders="filterPlaceholders"
            :selected-filters="selectedFilters"
            :show-filters="showFilters"
            :filters="filtersDataFiltered"
            :education-level="showEducationFilter"
            @filter-changed="updateSelectedFilters"
            @reset-filters="resetMoviesFilters"></PlayingNowFilters>

          <div class="b-pop-up__btn-area">
            <button
              type="submit"
              class="b-pop-up__btn-mobile"
              @click="closeFilterModal">
              {{ dictionary.result }}
            </button>
            <button
              type="reset"
              class="btn-cta b-pop-up__btn-reset"
              @click="resetMoviesFilters">
              {{ dictionary.clearFilter }}
            </button>
          </div>
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<script setup>
import { computed, nextTick, onBeforeMount, ref, watch } from 'vue'
import useViewport from '../../features/viewport'
import MovieHorizontalCard from '../components/MovieHorizontalCard.vue'
import MovieCard from '../components/MovieCard.vue'
import ModalOverlay from '../components/ModalOverlay.vue'
import PlayingNowFilters from '../components/PlayingNowFilters.vue'
import Sticky from '../components/UI/Sticky.vue'

const { desktop } = useViewport()
import { getData, moveWindowToObj } from '../../lib/lib'
// import { getMonthName } from '../../lib/date'
import jquery from 'jquery'
const { filters, records: movies, dictionary } = getData('movieOverviewData')
const tabsData = filters?.tabs || []

watch(desktop, () => {
  if (desktop.value) {
    closeFilterModal()
  }
})

const placeholderCinemas = dictionary.placeholderCinemas
  ? dictionary.placeholderCinemas
  : 'All'
const placeholderRoomType = dictionary.placeholderRoomType
  ? dictionary.placeholderRoomType
  : 'All'
const placeholderSreenAttr = dictionary.placeholderSreenAttr
  ? dictionary.placeholderSreenAttr
  : 'All'

const filterPlaceholders = computed(() => {
  return [placeholderCinemas, placeholderSreenAttr, placeholderRoomType]
})

const currentView = ref('horizontal')
const records = ref([])
const filteredRecords = ref([])
const filtersData = ref({})
const filtersDataFiltered = ref({})
const itemsPerPage = 9
const showAll = ref(false)
const tabs = ref([])
const activeTab = ref(null)
const allMovies = ref([])

const selectedFiltersIniValue = {
  cinemas: 'All',
  roomTypes: 'All',
  screenTypes: 'All',
  dates: 'All',
  // dates: filters.dates[0] ? filters.dates[0].value : [],
  genres: [],
  educationLevel: [],
}

const selectedFilters = ref({ ...selectedFiltersIniValue })
const genres = ref([])
const showMobileFiltersModal = ref(false)
const mobileCinemaSelect = ref('all')

const searchMovieTitle = ref('')
const moviesFiltersData = ref([])

const showFilters = computed(() => {
  // Always show the same base filters (cinemas, screenTypes, roomTypes)
  // This controls AgnosticFilterList only
  return ['cinemas', 'screenTypes', 'roomTypes']
})

const showEducationFilter = computed(() => {
  if (!tabsData || tabsData.length === 0) {
    return false
  }
  // Only show education filter if we're on the first tab AND there are movies with education levels
  const isEducationalTab = activeTab.value === tabsData[0].value
  if (!isEducationalTab) {
    return false
  }

  // Check if any movies in current records have education level data
  return records.value.some(
    (movie) =>
      movie.elementarySchool === true ||
      movie.middleSchool === true ||
      movie.highSchool === true,
  )
})

const cinemas = computed(() => {
  const availableCinemas = new Set()
  filteredRecords.value.forEach((movie) => {
    movie.cinemas?.forEach((cinemaId) => availableCinemas.add(cinemaId))
  })

  return (filters.cinemas || []).map((cinema) => ({
    ...cinema,
    disabled: !availableCinemas.has(cinema.value),
  }))
})

const selectedCinemaId = computed(() => {
  return selectedFilters.value.cinemas === 'All'
    ? ''
    : selectedFilters.value.cinemas
})

const handleMobileCinemaChange = () => {
  const cinemaFilter =
    mobileCinemaSelect.value === 'all' ? 'All' : mobileCinemaSelect.value
  selectedFilters.value.cinemas = cinemaFilter
  filterChanged(selectedFilters.value)
}

const displayedRecords = computed(() => {
  if (showAll.value) {
    return filteredRecords.value
  }
  return filteredRecords.value.slice(0, itemsPerPage)
})

const hasMoreRecords = computed(() => {
  return !showAll.value && filteredRecords.value.length > itemsPerPage
})
// const currentMonthName = computed(() => {
//   return getMonthName(new Date(), 'el')
// })

// Build filters from movie list
const buildFiltersFromMovies = (moviesList) => {
  // Build education level filters
  const educationLevels = new Set()
  moviesList.forEach((movie) => {
    if (movie.highSchool) {
      educationLevels.add('highSchool')
    }
    if (movie.middleSchool) {
      educationLevels.add('middleSchool')
    }
    if (movie.elementarySchool) {
      educationLevels.add('elementarySchool')
    }
  })

  const educationLevelFilters = Array.from(educationLevels)
    .sort((a, b) => {
      const order = ['highSchool', 'middleSchool', 'elementarySchool']
      return order.indexOf(a) - order.indexOf(b)
    })
    .map((level) => ({
      value: level,
      display: dictionary[level] || level,
    }))

  // Build genres filters
  const genresMap = new Map()
  moviesList.forEach((movie) => {
    if (movie.genreId && movie.genre) {
      genresMap.set(movie.genreId, movie.genre)
    }
  })

  const genreFilters = Array.from(genresMap).map(([id, name]) => ({
    value: id,
    display: name,
  }))

  // Build cinemas filters
  const cinemasMap = new Map()
  moviesList.forEach((movie) => {
    movie.cinemas?.forEach((cinemaId) => {
      const cinemaData = filters.cinemas?.find((c) => c.value === cinemaId)
      if (cinemaData) {
        cinemasMap.set(cinemaId, cinemaData)
      }
    })
  })

  return {
    educationLevel: educationLevelFilters,
    genres: genreFilters,
    cinemas: Array.from(cinemasMap.values()),
  }
}

onBeforeMount(() => {
  const builtFilters = buildFiltersFromMovies(movies)

  genres.value = builtFilters.genres
  allMovies.value = movies
  records.value = movies

  filtersData.value = { ...filters, ...builtFilters }
  filtersDataFiltered.value = { ...filtersData.value }
  filteredRecords.value = movies
  moviesFiltersData.value = filters.movies

  // Check if there's only one unique tab value across all records
  const uniqueTabValues = new Set()
  movies.forEach((movie) => {
    if (movie.tabs && Array.isArray(movie.tabs)) {
      movie.tabs.forEach((tab) => uniqueTabValues.add(tab))
    }
  })

  // Initialize tabs
  if (tabsData && tabsData.length > 0 && uniqueTabValues.size > 1) {
    // Multiple unique tab values exist, show tabs
    tabs.value = tabsData

    // Check if there's a tab parameter in the URL
    const urlParams = new URLSearchParams(window.location.search)
    const tabParam = urlParams.get('tab')

    // Use URL parameter if valid, otherwise use first tab
    if (tabParam && tabsData.some((tab) => tab.value === tabParam)) {
      activeTab.value = tabParam
      applyTabFilter(tabParam)
    } else {
      activeTab.value = tabsData[0].value
      applyTabFilter(tabsData[0].value)
    }
  } else {
    // No tabs available or only one unique tab value, show all movies
    tabs.value = []
    activeTab.value = null
  }

  updateFilteredOptions()
})

const recordGenres = (record) => {
  return [record.genre]
}

const filterChanged = async (filters, scroll = true) => {
  showAll.value = false
  if (Object.values(filters).every((filter) => filter === 'All')) {
    filteredRecords.value = records.value
  } else {
    filteredRecords.value = filterMoviesData(filters)
  }

  // Update available filter options based on filtered results
  updateFilteredOptions()

  await nextTick()
  if (scroll) {
    moveWindowToObj(jquery('.p-movies__outerwrapper'))
  }
}

const filterMoviesData = (filters) => {
  const filteredRecords = records.value.filter((record) => {
    const cinemaMatch =
      filters.cinemas === 'All' || record.cinemas.includes(filters.cinemas)

    const roomTypeMatch =
      filters.roomTypes === 'All' ||
      record.roomTypes.includes(filters.roomTypes)

    const screenTypeMatch =
      filters.screenTypes === 'All' ||
      record.screenTypes.includes(filters.screenTypes)

    const selectedDay = filtersData.value['dates'].find(
      (day) => day.value === filters.dates,
    )

    // const dateMatch = record.dates.includes(selectedDay.value)
    const dateMatch =
      filters.dates === 'All' || record.dates.includes(selectedDay.value)

    const genreMatch =
      filters.genres.length === 0 || filters.genres.includes(record.genreId)

    const educationLevelMatch =
      filters.educationLevel.length === 0 ||
      filters.educationLevel.some((level) => record[level] === true)

    return (
      cinemaMatch &&
      roomTypeMatch &&
      screenTypeMatch &&
      dateMatch &&
      genreMatch &&
      educationLevelMatch
    )
  })

  return filteredRecords
}

const closeFilterModal = () => {
  showMobileFiltersModal.value = false
}

const resetMoviesFilters = () => {
  resetMoviesFiltersOnly()
  emptyInput()
  filterChanged(selectedFilters.value)
}

const resetMoviesFiltersOnly = () => {
  selectedFilters.value = { ...selectedFiltersIniValue }
}

const startSearchMovies = (e) => {
  resetMoviesFiltersOnly()
  handleSearch(e.target.value)
}

function handleSearch(searchInput) {
  showAll.value = false
  // Filter records based on the search input
  const searchResults = records.value.filter((record) =>
    record.title.toLowerCase().includes(searchInput.toLowerCase()),
  )
  // Update the displayed records with search results
  filteredRecords.value = [...searchResults]
}

const showAllRecords = () => {
  showAll.value = true
}

const selectTab = (tabId) => {
  activeTab.value = tabId
  resetMoviesFilters()
  applyTabFilter(tabId)

  // Update URL with tab parameter
  const url = new URL(window.location)
  url.searchParams.set('tab', tabId)
  window.history.pushState({}, '', url)
}

const applyTabFilter = (tabValue) => {
  const currentTab = tabs.value.find((tab) => tab.value === tabValue)

  if (!currentTab) {
    records.value = allMovies.value
    filteredRecords.value = allMovies.value
    rebuildFilters(allMovies.value)
    return
  }

  // Filter movies based on tab value matching record's tabs array
  const tabMovies = allMovies.value.filter(
    (movie) => movie.tabs && movie.tabs.includes(tabValue),
  )

  records.value = tabMovies
  filteredRecords.value = tabMovies
  showAll.value = false
  rebuildFilters(tabMovies)
}

const updateFilteredOptions = () => {
  const currentFilters = selectedFilters.value

  // Check if a filter combination would have matching movies
  const hasResults = (testFilters) => {
    return records.value.some((movie) => {
      return (
        (testFilters.cinemas === 'All' ||
          movie.cinemas?.includes(testFilters.cinemas)) &&
        (testFilters.roomTypes === 'All' ||
          movie.roomTypes?.includes(testFilters.roomTypes)) &&
        (testFilters.screenTypes === 'All' ||
          movie.screenTypes?.includes(testFilters.screenTypes)) &&
        (testFilters.genres.length === 0 ||
          testFilters.genres.includes(movie.genreId)) &&
        (testFilters.educationLevel.length === 0 ||
          testFilters.educationLevel.some((level) => movie[level] === true))
      )
    })
  }

  // Generic function to mark filters as disabled
  const markDisabled = (filters, filterKey, value) => {
    return (
      filters?.map((filter) => ({
        ...filter,
        disabled: !hasResults({
          ...currentFilters,
          [filterKey]: value(filter),
        }),
      })) || []
    )
  }

  filtersDataFiltered.value = {
    educationLevel: markDisabled(
      filtersData.value.educationLevel,
      'educationLevel',
      (f) => [f.value],
    ),
    genres: markDisabled(filtersData.value.genres, 'genres', (f) => [f.value]),
    cinemas: markDisabled(filtersData.value.cinemas, 'cinemas', (f) => f.value),
    roomTypes: markDisabled(
      filtersData.value.roomTypes,
      'roomTypes',
      (f) => f.value,
    ),
    screenTypes: markDisabled(
      filtersData.value.screenTypes,
      'screenTypes',
      (f) => f.value,
    ),
    dates: filtersData.value.dates || [],
  }
}

const rebuildFilters = (moviesList) => {
  const builtFilters = buildFiltersFromMovies(moviesList)
  filtersData.value = { ...filters, ...builtFilters }
  updateFilteredOptions()
}

const emptyInput = () => {
  searchMovieTitle.value = ''
}

const updateSelectedFilters = (filters, scroll = true) => {
  selectedFilters.value = { ...filters }

  emptyInput()

  filterChanged(filters, scroll)
}
</script>
